<div class="p-2 m-2">
    <div class="d-none input-container d-flex justify-content-center m-auto mt-1" id="scan-box">
        <div class="d-none scanner-input-display {{MODE}} w-100 m-0 p-0" [class.scanning]="isScanning"  [class.warning]="scanStatus === 'warning'" [class.processing]="scanStatus === 'processing'">
            <div class="d-flex w-100">
                <div class="scanner-status col-5" *ngIf="!isMobile">
                    <mat-icon class="scanner-icon">
                        {{ scanStatus === 'error' ? 'error' : 
                        scanStatus === 'warning' ? 'warning' : 
                        scanStatus === 'processing' ? 'hourglass_empty' : 
                        isScanning ? 'scanner' : (isSearchMode ? 'search' : 'keyboard') }}
                    </mat-icon>
                    <span class="scanner-label">
                        {{isScanning ? 'Scanning...' : 'Ready'}}
                    </span>
                </div>

                <!-- Scanner Mode Input -->
                <div class="scanner-input col-7" *ngIf="!isSearchMode" [class.mobile-tappable]="isMobile">
                    <ng-container *ngIf="!isMobile">
                        <div class="d-flex flex">
                            <span class="input-value {{MODE}}">{{ keyBuffer || statusMessage }}</span>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
        <!-- Hidden input field for keyboard prevention -->
        <input #hiddenScanInput type="text" [formControl]="hiddenScanControl" class="hidden-scan-input" (focus)="onHiddenInputFocus()" (keydown)="onHiddenInputKeyDown($event)" autocomplete="off" tabindex="-1">
    </div>

   

    <div class="card-header m-0 p-0 " id="toptire">

        <div class="w-100 m-0 p-0 text-right" *ngIf="MODE && showcontrols && !touchKeyboard.isOpen">
            <p>RECDOC ITEMS ONLY &nbsp;<mat-slide-toggle [formControl]="recdoc_only"></mat-slide-toggle></p>
        </div>
        <mat-list *ngIf="dollyitems_reversed.length || (multiple_selection.length && !dollyitems_reversed.length)">
            
            <!-- processing -->
            <svg *ngIf="scanLabel == 'Processing'" class="spinner spin" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
            </svg>


            <!-- top tire -->
             <div class="top-tire" [ngClass]="{'slide-out-animate': scanLabel == 'Processing', 'slide-in-animate': scanLabel != 'Processing'}">
                <ng-container *ngIf="multiple_selection && MODE=='add'">
                    <div mat-subheader class="top-header {{MODE}}">
                        <span>Multiple Result Selection</span>
                        <span class="d-flex align-items-center">
                            <mat-icon style="scale: .7">directions</mat-icon>
                            {{this.bin_selected}}
                        </span>
                    </div>
                    <div class="m-0 p-0 active-dolly-item mat-elevation-z3">
                      
                        <div class="w-100 m-0 p-0 mt-2 bin-list">
                            <ng-container *ngFor="let loc of multiple_selection">
                                <div class="mult-item-list" (click)="selectItem(loc)" *ngIf="(recdoc_only.value && loc.recdoc_bin_present) || !recdoc_only.value">
                                    <div class="sku">
                                        <div *ngIf="loc.stockid === ''"><i>N/A</i></div>
                                        <div *ngIf="loc.stockid !== ''">{{ loc.stockid }}</div>
                                    </div>
                                    <div class="desc">
                                        <div>{{ loc.description }}</div>
                                    </div>
                                    <ng-container *ngFor="let bin of loc.bins_sorted">
                                        <div class="bin-item" *ngIf="bin.bin == loc.recdoc_bin_present">
                                            <div class="row justify-content-between ml-0 mr-0 flex" style="flex: 1">
                                                <div class="bin-label">
                                                    <div *ngIf="bin.bin === ''"><i>N/A</i></div>
                                                    <div *ngIf="bin.bin !== ''">{{ bin.bin }}</div>
                                                </div>
                                                <div class="bin-quantity">
                                                    <div>{{ bin.quantity }}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="!multiple_selection">
                    <div mat-subheader class="top-header {{MODE}}">
                        <span>TOP TIRE</span>
                        <span>
                            <b *ngIf="MODE != 'add'" style="display: flex; align-items: center;">
                                <ng-container *ngIf="bin_selected"> 
                                    <mat-icon style="scale: .7">directions</mat-icon>
                                    {{bin_selected}} 
                                </ng-container>
                                <ng-container *ngIf="!bin_selected"> PUT MODE </ng-container>
                            </b>
                            <b *ngIf="MODE == 'add'">ADD MODE</b>
                            
                        </span>
                    </div>
                    <div class="m-0 p-0 active-dolly-item mat-elevation-z3">
                        <mat-list-item class="h-auto">
                            <div class="m-0 p-0 w-100 item-desc">
                                <div class="col-12 m-0 p-0">
                                    <div matListItemTitle class="w-100 title m-0 p-0 text-dark">{{dollyitems_reversed[0].stockid}}</div>
                                    <div matListItemLine class="w-100 description m-0 p-0">{{dollyitems_reversed[0].description}}</div>
                                </div>
                            </div>
                        </mat-list-item>
                        <div class="w-100 m-0 p-0 mt-2 bin-list">
                            <ng-container *ngFor="let loc of dollyitems_reversed[0].bins_sorted">
                                <div class="bin-item d-block" [ngClass]="{ 'empty-bin': loc.quantity == '0', 'active-bin': this.startbin.getRawValue().toLowerCase() == loc.bin.toLowerCase()}" *ngIf="loc.defaultbin === '1' && !dontshowbins.includes(loc.bin)">
                                    <div class="row justify-content-around">
                                        <div class="bin-label">
                                            <div *ngIf="loc.bin === ''"><i>N/A</i></div>
                                            <div *ngIf="loc.bin !== ''">{{ loc.bin }}</div>
                                        </div>
                                        <div class="bin-quantity">
                                            <div>{{ loc.quantity }}</div>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                            <ng-container *ngFor="let loc of dollyitems_reversed[0].bins_sorted">
                                <div class="bin-item" [ngClass]="{ 'empty-bin': loc.quantity == '0', 'active-bin': this.startbin.getRawValue().toLowerCase() == loc.bin.toLowerCase()}" *ngIf="loc.defaultbin != '1' && loc.quantity > 0 && !dontshowbins.includes(loc.bin)">
                                    <div class="bin-label">
                                        <div *ngIf="loc.bin === ''"><i>N/A</i></div>
                                        <div *ngIf="loc.bin !== ''">{{ loc.bin }}</div>
                                    </div>
                                    <div class="bin-quantity">
                                        <span>{{ loc.quantity }}</span>
                                    </div>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="!dollyitems_reversed[0].bins_sorted.length || otherbinshidden(dollyitems_reversed[0].bins_sorted)">
                                <div class="bin-item">
                                    <div class="bin-label">
                                        <div>NO BINS IN SYSTEM</div>
                                    </div>
                                    <div class="bin-quantity">
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </ng-container>
              
            </div>
            </mat-list>


            <ng-container *ngIf="dollyitems_reversed.length >= 1">
                <div class="justify-content-between remaining-header mt-1 m-0 d-flex">
                    <span [ngClass]="{'d-none': dollyitems_reversed.length == 1}">Remaining</span>
                    <span>Total ({{dollyitems_reversed.length}})</span>
                </div>
                <mat-divider *ngIf="dollyitems_reversed.length > 1"></mat-divider>
            </ng-container>
            <!-- nexts -->
            <mat-list  class="dolly-list" id="dolly-list" *ngIf="dollyitems_reversed.length">
            <ng-container *ngFor="let i of dollyitems_reversed; let ind = index">
                <mat-list-item *ngIf="ind > 0" class="dolly-next-li inactive m-0 p-0 justify-content-between">
                        <div class="col-2 m-0 p-0 d-flex ">
                            <span class="dolly-index mat-elevation-z1">
                                {{dollyitems_reversed.length - ind}}
                            </span>
                        </div>
                        <div class="col-10 m-0 p-0 ">
                            <div matListItemTitle class="w-100 title text-right">{{i.stockid}}</div>
                            <!-- <div matListItemLine class="w-100 description">{{i.description}}</div> -->
                        </div>
                </mat-list-item>
            </ng-container>
        </mat-list>


        <!-- empty -->
        <div class="w-100 m-0 p-0 text-center" *ngIf="!dollyitems_reversed.length && !multiple_selection.length">
            <h4 class="dolly-missing">
                <ng-container *ngIf="dolly"> {{dolly.name}} is empty</ng-container>
                <ng-container *ngIf="!dolly"> Dolly not assigned </ng-container>
            </h4>
        </div>
       
       
        <!-- BOTTOM bar -->
        <div class="w-100 reconly" *ngIf=" MODE == 'add' && !keyboard.isOpen" (dblclick)="showcontrols = !showcontrols">
            <span class="p-1 mat-elevation-z3">
                <ng-container *ngIf="recdoc_only.value">Recdoc Bin</ng-container>
                <ng-container *ngIf="!recdoc_only.value">Any Bin</ng-container>
            </span>
         </div>
        


    </div>
</div>
<div class="warehouse-nav">
    <div class="input-container {{MODE}}" style="position: initial !important;" [class.error]="scanStatus === 'error'">
        <input class="bottom-mode w-100" ngxTouchKeyboard #touchKeyboard="ngxTouchKeyboard" type="text" [value]="isScanning ? keyBuffer : statusMessage"  id="searchRef" autocomplete="off"  #searchRef/>
        <button class="search-button" type="button" [ngClass]="{'processing': scanStatus == 'processing'}" (dblclick)="togglekeyboard(keyboard); ">
            <mat-icon *ngIf="scanStatus != 'processing'" class="input-button icon-shadow" [ngClass]="{'text-danger': scanStatus == 'error'}">
                <ng-container *ngIf="scanStatus != 'error'">keyboard</ng-container>
                <ng-container *ngIf="scanStatus == 'error'">warning</ng-container>
            </mat-icon>
            <svg *ngIf="scanStatus == 'processing'" class="spinner spin input-spinner" width="20px" height="20px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
            </svg>
        </button>
    </div>
</div>